import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActionSheetController, ModalController } from "@ionic/angular";
import { ViewPaymentDetailModel } from "src/app/model/ViewPaymentDetailModel";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ViewProfileDocumentComponent } from "src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
import { Page } from "src/app/model/Page";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { TdsApproveComponent } from "./approve-case/tds-approve-case.component";
import { TdsRejectComponent } from "./reject-case/tds-reject-case.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";

@Component({
  selector: "app-secure-view-payment-dtl",
  templateUrl: "./view-payment-dtl.component.html",
  styleUrls: ["./view-payment-dtl.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ViewPaymentDtlComponent implements OnInit {
  data: ViewPaymentDetailModel;
  page: Page<ViewPaymentDetailModel>;
  dataSource: MatTableDataSource<ViewPaymentDetailModel> =
    new MatTableDataSource();
  applicationNo: number;
  statusId: string;

  isLoading: boolean = false;
  manualRejectedQuestions: any[] = [];
  documents: any[] = [];
  verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];
  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  progressSpinnerDialog: any = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isSearchDisabled: boolean = false;
  displayedColumns: string[] = [
    "id",
    "installmentType",
    "installmentAmount",
    "delayDays",
    "interestAmount",
    // "totalAmountToBePaid",
    "totalwithinterestAmount",
    "settlementAmount",
    "pendingBalanceAmount",
    "onlinePaymentDate",
    // "settlementDate",
    // "balanceAmount",
    "transactionId",
    "utrNo",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  // isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  showtable: number = 5000001;
  source: string;
  paymentApprove: string;
  form: FormGroup = new FormGroup({});
  constructor(
    private route: ActivatedRoute,
    private paymentSettlementService: PaymentSettlementService,
    private modalCtrl: ModalController,
    private auditTrailService: AuditTrailService,
    private router: Router,
    public actionSheetController: ActionSheetController,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      paymentApprove: new FormControl(),
    });
    this.loadData();
  }

  loadData() {
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.statusId = params["paymentStatus"];

      this.source = params["source"];

      console.log("source", this.source, this.statusId);

      this.isLoading = true;
      this.paymentSettlementService
        .fetchDetailView(this.applicationNo)
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.data = data;
              console.log("this.data", this.data);
            } else {
              this.paymentSettlementService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            this.paymentSettlementService.errorToast(
              error?.error?.errorMessage || error?.error?.message
            );
          }
        );
      this.paymentSettlementService
        .fetchPaymentDetailView(this.applicationNo)
        .subscribe(
          (page: any) => {
            this.isLoading = false;
            console.log("Page ", page);
            this.page = page;
            if (page !== null && page !== "") {
              this.dataSource = new MatTableDataSource(page);
            } else {
              this.isLoading = false;
              this.paymentSettlementService.errorToast(page.errorMessage);
            }
            // setTimeout(() => {
            //   this.paginator.pageIndex = this.currentPage;
            //   this.paginator.length = page.totalElements;
            // });
            this.isSearchDisabled = false;
          },
          (error) => {
            console.log(error);
            this.isLoading = false;
            this.isSearchDisabled = false;
          }
        );
    });
  }

  showAsFile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchAsFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "16AS File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }
  onCheckboxCheck(e: any) {
    if (e.target) {
    }
  }
  showForm16BFile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchForm16BFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Form16B File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }

  showQbFile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchQbFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;

          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Qb File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }
  // async approve() {
  //   const modal = await this.modalCtrl.create({
  //       component: TdsApproveComponent,
  //       componentProps: {
  //           pan: this.applicationNo
  //       }
  //   });
  //   modal.present();

  //   const { data, role } = await modal.onWillDismiss();

  //   if (role === 'approve') {
  //       // this.onSubmit('APPROVED', null, data);
  //   }
  // }

  async reject() {
    const modal = await this.modalCtrl.create({
      component: TdsRejectComponent,
      componentProps: {
        pan: this.applicationNo,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === "reject") {
      console.log("DATA", data);
      // new API to update to update reject reasone
      this.paymentSettlementService
        .rejectedStatusFile(data, "REJECTED", this.applicationNo.toString())
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
          this.loadData();
          this._snackBar.open("TDS Certificate REJECTED", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "danger-toast",
            duration: 3 * 1000,
          });
        });

      // this.onSubmit('REJECTED', data);
    }
  }

  showChallanfile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchChallanFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Challan File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }

  statusFiles(status: any) {
    if (!this.data.form16bFile) {
      return this._snackBar.open("FORM16B file is required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    this.isLoading = true;
    this.paymentSettlementService
      .statusFile(status, this.applicationNo.toString())
      .subscribe((data) => {
        this.isLoading = false;
        this.loadData();
        console.log(data, "fromStatus files API");
        this._snackBar.open("TDS Certificate Approved", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "success-toast",
          duration: 3 * 1000,
        });
      });
  }
  accounntApprove(status: any) {
    console.log(
      "this.form.value.paymentApprove",
      this.form.value.paymentApprove
    );

    if (!this.form.value.paymentApprove) {
      return this._snackBar.open("Please Select  Check Box", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }

    let tdsFlag = false;
    if (this.data?.tenementCost >= 5000000) {
      if (this.data?.tdsCertificateStatus === "APPROVED") {
        tdsFlag = true;
      }
    } else {
      tdsFlag = true;
    }

    if (tdsFlag) {
      this.isLoading = true;
      this.paymentSettlementService
        .accountOfficerApprove(status, this.applicationNo.toString())
        .subscribe((data) => {
          this.isLoading = false;
          this.loadData();

          this._snackBar.open("Account Officer  Approved", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
          this.isLoading = true;
        });
    } else {
      this.paymentSettlementService.errorToast("Please approved TDS first.");
    }
  }
}
